import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=1860a19f"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDelete.vue?vue&type=style&index=0&id=1860a19f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1860a19f')) {
      api.createRecord('1860a19f', component.options)
    } else {
      api.reload('1860a19f', component.options)
    }
    module.hot.accept("./ConfirmDelete.vue?vue&type=template&id=1860a19f", function () {
      api.rerender('1860a19f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/dialog/ConfirmDelete.vue"
export default component.exports